import { render } from "./MEligibleRewards.vue?vue&type=template&id=1950dab9&scoped=true&ts=true"
import script from "./MEligibleRewards.vue?vue&type=script&lang=ts"
export * from "./MEligibleRewards.vue?vue&type=script&lang=ts"

import "./MEligibleRewards.vue?vue&type=style&index=0&id=1950dab9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1950dab9"]])

export default __exports__